'use strict';

/**
 *
 * @name: nnXTopics
 *
 */

import DirectiveTemplate from './nn-x-topics.directive.html';

function NnXTopicsDirective() {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    controller: nnXTopicsController,
    controllerAs: 'topicsList'
  };
}

function nnXTopicsController(
  $scope,
  apiModulesService,
  transObject
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var topicsList = this;
  topicsList.content = $scope.content();
  topicsList.data = apiModulesService.checkIfModuleHasData(topicsList.content) ? topicsList.content.tags : [];

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function _translateTopics() {

    topicsList.data.forEach(function(topic) {

      transObject.translate(topic);
    });
  }

  // function _loadTopics(options) {

  // }

  /**
   *
   * @INIT
   *
   */

  if (topicsList.data.length) {

    _translateTopics();
  } else {

    // _loadTopics();
  }
}

export default NnXTopicsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-x-topics/nn-x-topics.directive.js